(function () {
  const initSlider = (section) => {
    const sliderEl = section.querySelector(
      ".blog__posts-slider, .blog__posts-slider--mobile"
    );
    if (!sliderEl) return;

    const productsPerRow = Number(sliderEl.dataset.productsPerRow || 6);
    const productsPerRowMobile = Number(
      sliderEl.dataset.productsPerRowMobile || 1
    );

    const nextBtn = section.querySelector(
      ".heading-group__navigation-button-next"
    );
    const prevBtn = section.querySelector(
      ".heading-group__navigation-button-prev"
    );

    const paginationElement = section.querySelector(
      ".heading-group__pagination"
    );
    const slidesPerViewMobile = productsPerRowMobile;
    const slidesPerView576 = productsPerRow > 1 ? 2 : 1;
    const slidesPerView990 =
      productsPerRow > 2 ? slidesPerView576 + 1 : slidesPerView576;
    const slidesPerView1100 = productsPerRow >= 4 ? 4 : productsPerRow;
    const slidesPerView1360 = productsPerRow;

    const sliderSettings = {
      slidesPerView: slidesPerViewMobile,
      slidesPerGroup: slidesPerViewMobile,
      spaceBetween: 4,
      speed: 800,
      watchSlideProgress: true,
      allowTouchMove: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "swiper-button-disabled",
      },
      pagination: {
        el: paginationElement,
        type: "fraction",
      },
      breakpoints: {
        576: {
          slidesPerView: slidesPerView576,
          slidesPerGroup: slidesPerView576,
        },
        990: {
          slidesPerView: slidesPerView990,
          slidesPerGroup: slidesPerView990,
        },
        1100: {
          slidesPerView: slidesPerView1100,
          slidesPerGroup: slidesPerView1100,
        },
        1360: {
          slidesPerView: slidesPerView1360,
          slidesPerGroup: slidesPerView1360,
        },
      },
    };

    // support mobile-only sliders: class "blog__posts-slider--mobile"
    const isMobileOnly = sliderEl.classList.contains(
      "blog__posts-slider--mobile"
    );

    const handleInit = () => {
      const shouldInit = !isMobileOnly || window.innerWidth < 990;
      const postsWrapper = sliderEl.querySelector(".blog__posts");
      if (shouldInit) {
        // For mobile-only sliders we need to add Swiper classes to the DOM
        if (isMobileOnly) {
          sliderEl.classList.add("swiper");
          if (postsWrapper) postsWrapper.classList.add("swiper-wrapper");
          if (postsWrapper)
            postsWrapper.querySelectorAll(".blog__post").forEach((slide) => {
              slide.classList.add("swiper-slide");
            });
        }
        if (!sliderEl.swiper) new Swiper(sliderEl, sliderSettings);
      } else {
        if (sliderEl.swiper) {
          sliderEl.swiper.destroy();
          sliderEl.querySelector(".swiper-wrapper")?.removeAttribute("style");
          // remove inline styles only from active wrapper slides
          if (postsWrapper)
            postsWrapper.querySelectorAll(".swiper-slide").forEach((slide) => {
              slide.removeAttribute("style");
            });
        }
        // remove classes we added for mobile-only sliders
        if (isMobileOnly) {
          sliderEl.classList.remove("swiper");
          if (postsWrapper) postsWrapper.classList.remove("swiper-wrapper");
          if (postsWrapper)
            postsWrapper.querySelectorAll(".blog__post").forEach((slide) => {
              slide.classList.remove("swiper-slide");
            });
        }
      }
    };

    handleInit();

    // toggle on resize for mobile-only sliders
    if (isMobileOnly && !sliderEl._fb_resizeHandler) {
      sliderEl._fb_resizeHandler = () => handleInit();
      window.addEventListener("resize", sliderEl._fb_resizeHandler);
    }
  };

  const destroySlider = (section) => {
    const sliderEl = section.querySelector(
      ".blog__posts-slider, .blog__posts-slider--mobile"
    );
    if (!sliderEl) return;

    const postsWrapper = sliderEl.querySelector(".blog__posts");
    if (sliderEl.swiper) sliderEl.swiper.destroy();
    sliderEl.querySelector(".swiper-wrapper")?.removeAttribute("style");
    if (postsWrapper)
      postsWrapper.querySelectorAll(".swiper-slide").forEach((slide) => {
        slide.removeAttribute("style");
      });

    // remove resize handler if present
    if (sliderEl._fb_resizeHandler) {
      window.removeEventListener("resize", sliderEl._fb_resizeHandler);
      delete sliderEl._fb_resizeHandler;
    }
  };

  const initSectionLayout = (section) => {
    if (!section || !section?.classList.contains("section-featured-blog")) {
      return;
    }

    const box = section.querySelector(".blog");
    if (!box) return;

    const layout = box.dataset.layout;

    const sliderEl = box.querySelector(
      ".blog__posts-slider, .blog__posts-slider--mobile"
    );
    if (
      layout === "slider" ||
      (sliderEl && sliderEl.classList.contains("blog__posts-slider--mobile"))
    ) {
      initSlider(box);
    } else {
      destroySlider(box);
    }

    const calcSpecBlogHeight = (section) => {
      const specBlog = section?.querySelector(".blog__post--special");
      if (!specBlog) return;

      const elements = section.querySelectorAll(
        ".blog__posts--column-2 > .blog__post:nth-child(-n+2)"
      );

      if (!elements.length) return;

      const updateHeight = () => {
        let maxHeight = 0;

        elements.forEach((el) => {
          const imageHeight =
            el.querySelector(".article-card__image-wrapper")?.offsetHeight || 0;

          const contentHeight =
            el.querySelector(".article-content")?.offsetHeight || 0;

          const elHeight = imageHeight + contentHeight;

          if (elHeight > maxHeight) maxHeight = elHeight;
        });

        section.style.setProperty("--spec-blog-height", `${maxHeight}px`);
      };

      const observer = new ResizeObserver(updateHeight);

      elements.forEach((el) => observer.observe(el));

      window.addEventListener("resize", updateHeight);
      updateHeight();
    };

    calcSpecBlogHeight(section);
  };

  initSectionLayout(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initSectionLayout(event.target);
  });
})();
